import { Component, Input, OnInit } from "@angular/core";
import { Action } from "@app/models";
import { TranslateService } from "@ngx-translate/core";
import { Observable, switchMap } from "rxjs";
import { ActionListItemService } from "../../services/action-list-item.service";

@Component({
  selector: "action-task-deleted",
  template: `
    <div class="display-flex-start">
      <span [innerHTML]="text | async" class=""></span>&nbsp;
      <contact-summary [contactId]="item.contactId"></contact-summary>
    </div>
    <div>
      <small *ngIf="item.param2?.length > 0" class="text-muted">
        <strong>{{ "type" | translate }}: </strong>{{ item.param2 }}
      </small>
    </div>
  `,
  styleUrls: ["./common.scss"],
})
export class ActionTaskDeletedComponent implements OnInit {
  @Input() item: Action;

  text: Observable<string>;

  classTask = "action-task-deleted-task";

  constructor(
    private translateService: TranslateService,
    public itemService: ActionListItemService
  ) {}

  ngOnInit() {
    this.text = this.itemService.getYouTranslation(this.item).pipe(
      switchMap((youString: string) =>
        this.translateService.get("action_task_delete_text", {
          task: `<span class="${this.classTask}">"${this.item.param1}"</span>`,
          you: youString,
        })
      )
    );
  }
}
